import type { RouteObject } from "react-router-dom";

import { Spinner } from "@/components/ui/v2/spinner";

import { CompanyMarketplace } from "@/pages/(home)/(company)/marketplace";
import { addSlashes, withCompanyPrefix } from "../route.utils";

export enum COMPANY_MARKETPLACE_PATH_SEGMENTS {
  ROOT = "marketplace",
}

export const companyMarketplaceRoutes: RouteObject = {
  path: COMPANY_MARKETPLACE_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner,
  handle: { breadcrumb: "Marketplace" },
  children: [{ index: true, Component: CompanyMarketplace }],
};

export const COMPANY_MARKETPLACE_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_MARKETPLACE_PATH_SEGMENTS.ROOT)),
});
